import React, { useEffect, useRef } from 'react';
import { Col, Image } from 'react-bootstrap';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../UI/Button/Button';

const HighlightsItem = props => {
    const video = useRef(null);
    useEffect(() => {
        if (!video.current)
            return;

        if (props.inView)
            video.current.play();
        else
            video.current.pause();
    }, [props.inView])
    const icon = props.video ? <div className="icon-video"><video ref={video} loop playsInline muted src={props.video} /></div>
        : <Image className="w-100" src={props.image} roundedCircle />;

    if (props.custom) {
        return (
            <Col className="px-4 custom justify-content-center align-items-center d-flex flex-column d-md-block" xs={{ span: 12, offset: 0 }} sm={{ span: 6, offset: 0 }} lg={4}>
                <h3 className="d-block d-md-none h2 fw-700 text-uppercase ">
                    <div className="title-triangle top-sm"></div>
                    <Trans i18nKey={props.title} components={{ br: " " }} />
                    {/* {props.title} */}
                </h3>
                <h3 className="d-md-block d-none h4 fw-700 text-uppercase">
                    <div className="title-triangle top-sm"></div>
                    <Trans i18nKey={props.title} components={{ br: <br /> }} />
                    {/* {props.title} */}
                </h3>
                <Col className="px-0 pt-3 pb-3 pb-md-5" xs={6} md={{ span: 8, offset: 2 }} lg={{ span: 12, offset: 0 }}>
                    {icon}
                </Col>
                <p><Trans i18nKey={props.text} components={{ bold: <strong /> }} /></p>
            </Col>
        );
    } else {
        return (
            <Col className="px-4" xs={{ span: 6, offset: 0 }} sm={{ span: 6, offset: 0 }} lg={3}>
                <h2 className="h4 fw-700 text-uppercase">
                    <div className="title-triangle top-sm"></div>
                    {props.t('homepage:section-2.' + props.id + '.title')}
                </h2>
                <Col className="px-0 pt-3 pb-5" xs={10} md={{ span: 8, offset: 2 }} lg={{ span: 12, offset: 0 }}>
                    {icon}
                    <Link to={props.t('routes:' + props.id + '.path') + "#top"}>
                        <Button btnClasses={'wh-35 h5 fw-600 text-uppercase float-right mr-0 mt-0 black'}>+</Button>
                    </Link>
                </Col>
                <p>{props.t('homepage:section-2.' + props.id + '.txt')}</p>
            </Col>
        );
    }
};

export default withTranslation(['routes', 'homepage'])(HighlightsItem);